import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          "--normal-bg": "#FFFFFF",
          "--normal-text": "#1A1A1A",
          "--normal-border": "#E8E4DF",
          "--border-radius": "0.625rem",
          "--success-bg": "#FFFFFF",
          "--success-text": "#1A1A1A",
          "--success-border": "#E8E4DF",
          "--error-bg": "#FFFFFF",
          "--error-text": "#C41E2A",
          "--error-border": "#E8E4DF",
          "--info-bg": "#FFFFFF",
          "--info-text": "#1A1A1A",
          "--info-border": "#E8E4DF",
          "--warning-bg": "#FFFFFF",
          "--warning-text": "#1A1A1A",
          "--warning-border": "#E8E4DF",
          fontFamily: "'DM Sans Variable', sans-serif",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          title: "text-sm font-medium",
          description: "text-xs text-[#6B6B6B]",
          success: "[&_svg]:text-[#2E7D32]",
          error: "[&_svg]:text-[#C41E2A]",
          warning: "[&_svg]:text-[#D4A853]",
          info: "[&_svg]:text-[#3A3A3C]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
